module.exports = __webpack_public_path__ + "img/swiftspace.ac0269bb.png";